var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpClient } from "@/lib/http";
// GDA KPI Type definitions
export const GDA_KPI_TYPES = [
    { value: "area", label: "Área" },
    { value: "region", label: "Región" },
    { value: "delegation", label: "Delegación" },
    { value: "sala", label: "Sala" },
    { value: "distribuidor", label: "Distribuidor" },
];
export function fetchGdaCentersKpi() {
    return __awaiter(this, arguments, void 0, function* (params = {}) {
        const url = "/webapi/resultados/gda-centers-kpi-global-performance";
        const response = yield HttpClient.post(url, params);
        return response !== null && response !== void 0 ? response : [];
    });
}
